import * as React from "react";
import "../../Home.scss";
import "./SuccessStories.scss";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const PUBLIC_URL = process.env.PUBLIC_URL;

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 1
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 1
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 1
  }
};


const SucceessStories: React.FC = () => {

  const arrow = (onClick, alignLeft) => {
    return (
      <i tabIndex={0} onKeyDown={() => onClick()} className={`${alignLeft == true ? "arrow-left" : "arrow-right"}`}
        onClick={() => onClick()}></i>
    )
  }

  const CustomRightArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;

    return (
      arrow(onClick, false)
    )
  };

  const CustomleftArrow = ({ onClick, ...rest }) => {
    const {
      onMove,
      carouselState: { currentSlide, deviceType }
    } = rest;

    return (
      arrow(onClick, true)
    )
  };

  return (
    <div className="section bg-image">
      <div className="wrap-section-1">
        <div className="headline-6-col">
          <h2 className="header-tag">
            Check out what developers are saying about Mindbody
          </h2>
        </div>
        <Carousel
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={4000}
          arrows={true}
          customLeftArrow={<CustomleftArrow onClick />}
          customRightArrow={<CustomRightArrow onClick />}
          dotListClass="pos-slider"
          containerClass="container container-one"
          itemClass="carousel-li"
          renderDotsOutside={true}
          responsive={responsive}
          showDots>
          <div className="slider-div">
            <div className="logos">
              <div className="logo-circle">
                <img width="250" className="studio-ease-icon-img" alt="studio-ease-icon"></img>
              </div>
            </div>
            <div className="company-text">
              <p className="company-text-para">"After having worked with the Mindbody API for many years, the improvements in features and functionality, especially the addition of webhooks, have enabled StudioEase to take our innovative concepts and bring them to the marketplace. Without a strong API connection, we would not have been able to expand on the core MindBody infrastructure."
               </p>
              <div className="developer-name">
                Mike Huck,
               </div>
              <div className="developer-info">
                Studioease
               </div>
            </div>
          </div>
          <div className="slider-div">
            <div className="logos">
              <div className="logo-circle">
                <img className="company-logo-adp adp-icon-img" width="250" alt="adp-icon"></img>
              </div>
            </div>
            <div className="company-text">
              <p className="company-text-para">"The Mindbody connector has been a game changer for many of our mutual clients and we are thrilled to have such a great collaboration with Mindbody. Our teams love to see our mutual clients thrive by helping them eliminate the time and errors inherent to the manual entry of payroll data."
               </p>
              <div className="developer-name">
                ADP
               </div>
            </div>
          </div>
          <div className="slider-div">
            <div className="logos">
              <div className="logo-circle">
                <img className="panda-logo-current panda-icon-img" width="250" alt="panda-icon"></img>
              </div>
            </div>
            <div className="company-text">
              <p className="company-text-para">"Working with Mindbody on this beta program far surpassed my expectations.  You really gave me everything I needed to make it successful."
              </p>
              <div className="developer-name">
                Pandaflow
               </div>
            </div>
          </div>
        </Carousel>
      </div>
      <div id={'landingPricing'}></div>
    </div>
  );
};

export default SucceessStories;
